import React from "react";
import ToolBar from "../../../components/toolbar/ToolBar";
import url from '../../../url'
import Select from "react-select";
import { Input, Label } from 'reactstrap'
import axios from "axios";
import { getFDate } from "../../../util/date";
import { store } from 'react-notifications-component';
import Loading from "../../../components/loading/Loading";
import ModernAlert from "../../../components/alert/ModernAlert";
import CardIcon from "../../../components/card-icon-dash/CardIcon";
import './performance-telemetria.css'
import ListEvents from "../../../components/list-events/ListEvents";
import LGCard from "../../../components/lg-card/LGCard";
import CustomGauge from "../../../components/custom-gauge/CustomGauge";
import CustomDunut from "../../../components/custom-dunnut/CustomDunut";
import BasicScoreTable from "../../../components/basic-score-table/BasicScoreTable";
import EventsLine from "../../../components/events-line/EventsLine";


class PerformanceTelemetria extends React.Component {
    topCards1 = [
        { label: 'Motorista / Veículos', value: '69', icon: 'https://stc.telemetry.com.br/panel/dashboard-icons/driver.png' },
        { label: 'Distância (KM)', value: '304.044,14', icon: 'https://stc.telemetry.com.br/panel/dashboard-icons/km.png' },
        { label: 'Média (Km/l)', value: '2,76', icon: 'https://stc.telemetry.com.br/panel/dashboard-icons/fuel.png' },
        { label: 'Horas de Condução', value: '7.194,10', icon: 'https://stc.telemetry.com.br/panel/dashboard-icons/drive-hours.png' },
    ]
    topCards2 = [
        { label: 'Horas Ociosas', value: '1.333,68', icon: 'https://stc.telemetry.com.br/panel/dashboard-icons/idle-hours.png' },
        { label: 'Total de Eventos', value: '5.147', icon: 'https://stc.telemetry.com.br/panel/dashboard-icons/calendar.png' },
        { label: 'Ociosidade Consumo em Litros', value: '4,85', icon: 'https://stc.telemetry.com.br/panel/dashboard-icons/idle-liters.png' },
        { label: 'Ociosidade Consumo em Real', value: 'R$ 1.567,09', icon: 'https://stc.telemetry.com.br/panel/dashboard-icons/idle-price.png' },
    ]



    constructor(props) {
        super(props)

        this.state = {
            drivers: { options: [], loading: false },
            licenseNumbers: { options: [], loadingD: false },
            groups: [],
            table: {},
            alert: { msg: '', type: '' },
            loading: true,
            topCards1: [],
            topCards2: [],
            driverMecEventAttr: {},
            vehicleMecEventAttr: {},
            avgFuelAttr: {},
            avgSecurityFactorAttr: {},
            totalEventsSecMec: {},
            driverData: {},
            EventsRealized: {},
            loadingEvents: true,
            filter: {
                startPeriod: "",
                endPeriod: "",
                groupName: [],
                idDrivers: [],
                idVehicles: [],
                vehicleGroup: false
            }

        }
    }




    componentDidMount() {
        this.getGroups();
        this.getRancking()
    }
    getGroups = () => {
        axios
            .get(`${url}/v1/telemetria/admin/cache/groups/${this.props.token}`)
            .then(d => {
                // console.log(d.data);
                let groups = [];
                for (let i = 0; i < d.data.length; i++) {
                    groups.push({ value: d.data[i].name, label: d.data[i].name });
                }
                this.setState({ groups });
            })
            .catch(e => console.log(e.response));
    };

    getEventsRealized = () => {
        this.setState({ loadingEvents: true, });
        axios.post(`${url}/v1/telemetria/admin/report/dashboard/listEvents/${this.props.token}`, this.state.filter)
            .then(d => {
                console.log(d.data)
                this.setState({ EventsRealized: d.data, loadingEvents: false })
            })
            .catch(e => {
                console.log(e)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loadingEvents: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };
    
    getRancking = (data) => {
        this.setState({ loading: true, table: {}, alert: { msg: '', type: '' } });
        // console.log(data)
        axios({
            method: !data ? 'get' : 'post',
            url: `${url}/v1/telemetria/admin/report/dashboard/${this.props.token}`,
            data
        })
            .then(d => {
                console.log(d.data)
                if (d.data.title === 'Erro no relatório semanal') {
                    store.addNotification({ ...this.props.bodyNotify, title: d.data.title, type: 'danger' });
                    this.setState({
                        loading: false,
                        alert: {
                            type: "danger",
                            msg:
                                d.data.title
                        }
                    });
                } else if (!d.data.listGeneralAttr.length) {
                    this.setState({
                        loading: false,
                        filter: { ...this.state.filter },
                        alert: {
                            type: "",
                            msg:
                                "Não foi possivel localizar resultados para o período selecionado."
                        }
                    });
                }  else {
                    const topCards1 = [
                        { label: d.data.listGeneralAttr[0].label, value: d.data.listGeneralAttr[0].value, icon: 'https://stc.telemetry.com.br/panel/dashboard-icons/driver.png' },
                        { label: d.data.listGeneralAttr[1].label, value: d.data.listGeneralAttr[1].value, icon: 'https://stc.telemetry.com.br/panel/dashboard-icons/km.png' },
                        { label: d.data.listGeneralAttr[2].label, value: d.data.listGeneralAttr[2].value, icon: 'https://stc.telemetry.com.br/panel/dashboard-icons/fuel.png' },
                        { label: d.data.listGeneralAttr[3].label, value: d.data.listGeneralAttr[3].value, icon: 'https://stc.telemetry.com.br/panel/dashboard-icons/drive-hours.png' },
                    ]
                    const topCards2 = [
                        { label: d.data.listGeneralAttr[4].label, value: d.data.listGeneralAttr[4].value, icon: 'https://stc.telemetry.com.br/panel/dashboard-icons/idle-hours.png' },
                        { label: d.data.listGeneralAttr[5].label, value: d.data.listGeneralAttr[5].value, icon: 'https://stc.telemetry.com.br/panel/dashboard-icons/calendar.png' },
                        { label: d.data.listOtherAttr[0].label, value: d.data.listOtherAttr[0].value, icon: 'https://stc.telemetry.com.br/panel/dashboard-icons/idle-liters.png' },
                        { label: d.data.listOtherAttr[1].label, value: d.data.listOtherAttr[1].value, icon: 'https://stc.telemetry.com.br/panel/dashboard-icons/idle-price.png' },
                    ]
                    this.setState({
                        loading: false,
                        loadingF: false,
                        topCards1,
                        topCards2,
                        driverMecEventAttr: { title: 'Motoristas Eventos Mecânicos', listData: d.data.driverMecEventAttr.listData },
                        vehicleMecEventAttr: { title: 'Motoristas Eventos Segurança', listData: d.data.vehicleMecEventAttr.listData },
                        totalEventsSecMec: d.data.totalEvents,
                        avgFuelAttr: d.data.avgFuelAttr,
                        avgSecurityFactorAttr: d.data.avgSecurityFactorAttr,
                        driverData: d.data.driverData,
                        filter: {...d.data.reportForm, groupName: []}
                    })
                    this.getEventsRealized();
                }
                //console.log(d.data);
            })
            .catch(e => {
                console.log(e)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };

    renderToolbar = () => {
        return (
            <ToolBar zero={true}>
                <div>
                    <label htmlFor="start-date" className='toolbar-label'>Inicio</label>
                    <input
                        id='start-date'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, startPeriod: i.target.value } })}
                        disabled={this.state.loading}
                        placeholder='Inicio'
                        max={getFDate()}
                        value={this.state.filter.startPeriod} />
                </div>

                <div>

                    <label htmlFor="end-period" className='toolbar-label'>Fim</label>
                    <input
                        id='end-period'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, endPeriod: i.target.value } })}
                        disabled={this.state.loading || !this.state.filter.startPeriod}
                        min={this.state.filter.startPeriod}
                        max={getFDate()}
                        value={this.state.filter.endPeriod}
                    />
                </div>

                <div>
                    <label htmlFor="drivers" className='toolbar-label'>Motoristas</label>
                    {/* Select Motoristas */}
                    <Select
                        inputId='drivers'
                        isLoading={this.state.drivers.loading}
                        className='toolbar-select'
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Motoristas"
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise os motoristas!' : `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.drivers.options}
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, idDrivers: [] } })
                            }
                            else {
                                let idDrivers = []
                                i.forEach(d => idDrivers.push(d.value))
                                this.setState({ filter: { ...this.state.filter, idDrivers } })
                            }
                        }}
                        onInputChange={(i) => {
                            if (i.length > 2) {
                                this.setState({ drivers: { ...this.state.drivers, loading: true } });
                                axios
                                    .get(`${url}/v1/telemetria/admin/cache/drivers/${encodeURI(i)}/${this.props.token}`)
                                    .then(d => {
                                        let options = [];
                                        d.data.forEach(d => options.push({ label: d.driverName, value: d.driverId }))
                                        this.setState({ drivers: { options, loading: false } });
                                    })
                                    .catch(e => console.log(e.response));
                            }
                        }}
                        isDisabled={this.state.loading}
                    />
                </div>
                <div>
                    <label htmlFor="vehicles" className='toolbar-label'>Frotas</label>
                    {/* Select Frotas */}
                    <Select
                        inputId='vehicles'
                        isLoading={this.state.licenseNumbers.loadingD}
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Frotas"
                        className='toolbar-select'
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise as frotas!' : `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.licenseNumbers.options}
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, idVehicles: [] } })
                            }
                            else {
                                let idVehicles = []
                                i.forEach(d => idVehicles.push(d.value))
                                this.setState({ filter: { ...this.state.filter, idVehicles } })
                            }
                        }}
                        onInputChange={(i) => {
                            if (i.length > 2) {
                                this.setState({ licenseNumbers: { ...this.state.licenseNumbers, loading: true } });
                                axios
                                    .get(`${url}/v1/telemetria/admin/cache/vehicles/${encodeURI(i)}/${this.props.token}`)
                                    .then(d => {
                                        let options = [];
                                        d.data.forEach(d => options.push({ label: d.licenseNmbr, value: d.vehicleId }))
                                        this.setState({ licenseNumbers: { options, loading: false } });
                                    })
                                    .catch(e => console.log(e.response));
                            }
                        }}
                        isDisabled={this.state.loading}
                    />
                </div>
                <div>
                    <label htmlFor="groups" className='toolbar-label'>Grupos</label>

                    {/* Select Grupos */}
                    <Select
                        // isDisabled={this.state.loading}
                        // isLoading={this.state.collab.loading}
                        inputId='groups'
                        className='toolbar-select'
                        isMulti
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Grupo"
                        noOptionsMessage={e => { return `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.groups}
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, groupName: [] } })
                            }
                            else {
                                let groupName = []
                                i.forEach(d => groupName.push(d.value))
                                this.setState({ filter: { ...this.state.filter, groupName } })
                            }
                        }}
                        isClearable
                        isDisabled={this.state.loading} />
                    <Label check className='toolbar-label'>
                        <Input
                            type="checkbox"
                            onChange={() => this.setState({ filter: { ...this.state.filter, vehicleGroup: !this.state.filter.vehicleGroup } })}
                            checked={this.state.filter.vehicleGroup}
                            disabled={this.state.loading}
                        />{" "}
                        Agrupar por veículo
                    </Label>
                </div>
                <input
                    type="button"
                    value='Filtrar'
                    className='telemetry-button toolbar-button'
                    onClick={() => this.getRancking(this.state.filter)}
                    disabled={!this.state.filter.startPeriod || !this.state.filter.endPeriod || this.state.loading}
                />

            </ToolBar>
        )
    }


    render() {
        return (
            <div>
                {this.renderToolbar()}

                {this.state.loading ? (
                    <div className='app-tool-center-loading '>
                        <Loading />
                    </div>
                ) : !this.state.alert.msg ? (
                    <div>
                        {/* Geral */}
                        <div className="row row-inside">
                            {/* TopCards 1 */}
                            <div className="col-lg-12 col-xl-6 no-padding">
                                <div className="row row-inside">
                                    {this.state.topCards1.map((d, i) => {
                                        return (
                                            <div className="col-6 col-sm-3 col-card-icon" key={i}>
                                                <CardIcon data={d} />
                                            </div>
                                        )
                                    })}

                                </div>
                            </div>
                            {/* TopCards 2 */}
                            <div className="col-lg-12 col-xl-6 no-padding">
                                <div className="row row-inside">
                                    {this.state.topCards2.map((d, i) => {
                                        return (
                                            <div className="col-6 col-sm-3 col-card-icon" key={i}>
                                                <CardIcon data={d} />
                                            </div>
                                        )
                                    })}

                                </div>
                            </div>

                            {/* Lista de Eventos */}
                            <div className="col-lg-12 col-xl-6 no-padding">
                                <div style={{ width: '100%', }}>
                                    <div className="row row-inside">
                                        <div className="col-md-6 col-xl-6 col-card-icon">
                                            <ListEvents list={this.state.driverMecEventAttr.listData} title={this.state.driverMecEventAttr.title} />
                                        </div>
                                        <div className="col-md-6 col-xl-6 col-card-icon list-events-mg-top">
                                            <ListEvents list={this.state.vehicleMecEventAttr.listData} title={this.state.vehicleMecEventAttr.title} />
                                        </div>

                                    </div>

                                </div>

                            </div>

                            {/* Gauge / Fator segurança / Eventos */}
                            <div className="col-lg-12 col-xl-6 no-padding gauge-mg-top">
                                <div style={{ width: '100%', height: '450px' }}>
                                    <div className="row row-inside">
                                        <div className="col-md-6 col-xl-6 col-card-icon">
                                            <div style={{ width: '100%', height: '290px' }}>
                                                <CustomGauge data={this.state.avgFuelAttr} />
                                            </div>
                                            <div style={{ width: '100%', height: '150px', marginTop: '10px' }}>
                                                <LGCard data={this.state.avgSecurityFactorAttr} />
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-xl-6 col-card-icon mg-dunut">
                                            <div style={{ width: '100%', height: '450px' }}>
                                                <CustomDunut data={this.state.totalEventsSecMec} />
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>

                            {/* Motoristas */}
                            <div className="col-lg-12 col-xl-6 no-padding mg-767" >
                                <div style={{ width: '100%', marginTop: '10px', height: '370px' }}>
                                    <div className="row row-inside">
                                        <div className="col-12 col-card-icon">
                                            <BasicScoreTable data={this.state.driverData} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Grafico eventos realizados */}
                            <div className="col-lg-12 col-xl-6 no-padding">

                                <div style={{ width: '100%', marginTop: '10px' }}>
                                    <div className="row row-inside">
                                        <div className="col-12 col-card-icon">
                                            {this.state.loadingEvents ? (
                                                <div className="events-line-container" style={{height: '370px'}}>
                                                    <Loading />
                                                </div>
                                            ) : (
                                                <EventsLine data={this.state.EventsRealized} />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                ) : null}
                <div style={{ width: '440px', marginTop: '20px', alignSelf: 'center' }}>
                    <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                </div>
            </div>
        )
    }

}

export default PerformanceTelemetria